export class OAuth2CodeFlowConfiguration {
  connection: string;
  domain: string;
  audience: string;
  clientId: string;
  redirectUri: string;
}
